import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import Flickity from 'flickity'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swup from 'swup';

window.Alpine = Alpine
Alpine.plugin(collapse)
Alpine.start()
gsap.registerPlugin(ScrollTrigger);


// Animate each element with the class 'animate' one by one with a delay
gsap.utils.toArray('.animate').forEach((element, index) => {
	gsap.from(element, {
	  scrollTrigger: {
		trigger: element,
		start: "top 80%", // Start the animation when the top of the element is 80% from the top of the viewport
		end: "top 50%", // End the animation when the top of the element is 50% from the top of the viewport
		scrub: true, // Smooth scrubbing, takes 1 second to "catch up" to the scrollbar
	  },
	  y: 150, // Move from 150px below
	  opacity: 0, // Start with opacity 0
	  duration: 1, // Duration of the animation
	  delay: index * 0.2, // Delay each element by 0.2 seconds multiplied by its index
	});
  });